import React, { ComponentProps, ComponentType, JSXElementConstructor } from 'react';
import cx from 'classnames';
import Loading from '@/components/Common/Loading';
import * as styles from './Button.module.scss';

export enum ButtonVariant {
  Primary = 'primary',
  Secondary = 'secondary',
  Ghost = 'ghost',
  Bare = 'bare',
}

type Props<TComponentType extends JSXElementConstructor<any>> =
  ComponentProps<TComponentType> & {
    as?: ComponentType;
    variant?: ButtonVariant;
    isLoading?: boolean;
  };

const Button = <TComponentType extends JSXElementConstructor<any>>({
  as: Component = 'button',
  type = 'button',
  children,
  variant = ButtonVariant.Bare,
  isLoading,
  ...props
}: Props<TComponentType>) => (
  <Component
    {...props}
    type={type as HTMLButtonElement['type']}
    className={cx(
      styles.main,
      {
        [styles.isPrimary]: variant === ButtonVariant.Primary,
        [styles.isSecondary]: variant === ButtonVariant.Secondary,
        [styles.isGhost]: variant === ButtonVariant.Ghost,
        [styles.isBare]: variant === ButtonVariant.Bare,
      },
      props.className
    )}
  >
    {isLoading ? <Loading /> : children}
  </Component>
);

export default Button;
